import { render, staticRenderFns } from "./CreateCollection.vue?vue&type=template&id=bd0b60e2&"
import script from "./CreateCollection.js?vue&type=script&lang=js&"
export * from "./CreateCollection.js?vue&type=script&lang=js&"
import style0 from "./CreateCollection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports